import {
  BaseIcon
} from "./chunk-Z3LMOCJ7.mjs";

// src/icons/networks/NetworkCronos.tsx
import { forwardRef } from "react";
import { Fragment, jsx, jsxs } from "react/jsx-runtime";
var NetworkCronos = forwardRef(
  ({ variant = "mono", ...props }, ref) => /* @__PURE__ */ jsx(BaseIcon, { ...props, ref, children: variant === "mono" ? /* @__PURE__ */ jsxs(Fragment, { children: [
    /* @__PURE__ */ jsx(
      "path",
      {
        fill: "currentColor",
        d: "M12.003 2 3.25 7.002v10L12.003 22l8.747-4.998v-10zm6.156 13.52-6.156 3.517-6.158-3.517V8.48l6.158-3.517L18.16 8.48z"
      }
    ),
    /* @__PURE__ */ jsx(
      "path",
      {
        fill: "currentColor",
        d: "M16.084 14.338 12 16.67l-4.09-2.332v-4.67L12 7.33l4.085 2.337-1.7.972L12 9.274l-2.385 1.365v2.722L12 14.725l2.385-1.364z"
      }
    )
  ] }) : /* @__PURE__ */ jsxs(Fragment, { children: [
    /* @__PURE__ */ jsx(
      "path",
      {
        fill: "#051221",
        d: "M12.003 2 3.25 7.002v10L12.003 22l8.747-4.998v-10zm6.156 13.52-6.156 3.517-6.158-3.517V8.48l6.158-3.517L18.16 8.48z"
      }
    ),
    /* @__PURE__ */ jsx(
      "path",
      {
        fill: "#051221",
        d: "M16.084 14.338 12 16.67l-4.09-2.332v-4.67L12 7.33l4.085 2.337-1.7.972L12 9.274l-2.385 1.365v2.722L12 14.725l2.385-1.364z"
      }
    )
  ] }) })
);
NetworkCronos.displayName = "cronos";
var NetworkCronos_default = NetworkCronos;

export {
  NetworkCronos_default
};
